import faker from '@faker-js/faker';
import {TRefundPeriod} from './types';

export const getRefundPeriod = (): TRefundPeriod => {
  const cycles = ['daily', 'weekly', 'bi_monthly', 'monthly'];
  return {
    reserved: faker.datatype.boolean(),
    cycle: (faker.helpers as any).arrayElement(cycles),
    reserved_days: +faker.finance.amount(0, 1000, 2),
  } as TRefundPeriod;
};
